<div class="wrapper">
  <div class="box">
    <h1>500</h1>
    <p>Sorry, it's me, not you.</p>
    <!--<p>&#58;&#40;</p>
    <p><a href="/">Let me try again!</a></p>-->
    <h5>{{errorUrl}}</h5>
    <p>{{errorMessage1}}</p>
    <p>{{errorMessage2}}</p>
  </div>
</div>
